export const INCREMENT = 'INCREMENT';
export const DECREMENT = 'DECREMENT';
export const DEVIDE = 'DEVIDE';

// Authentication types
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT = 'LOGOUT';
export const CLEAR_AUTH_ERROR = 'CLEAR_AUTH_ERROR';
export const SESSION_EXTENDED = 'SESSION_EXTENDED';
export const AUTH_INITIALIZED = 'AUTH_INITIALIZED';